// Angular
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

// NGX
import { LoggerModule } from 'ngx-logger';

// env config
import { environment } from '@env/environment';

//IADE
import { ActivationModule } from '@modules/activation/activation.module';
import { ConnexionModule } from '@modules/connexion/connexion.module';
import { EspaceClientModule } from '@modules/espace-client/espace-client.module';
import { SouscriptionModule } from '@modules/souscription/souscription.module';
import { BasculeMobileModule } from '@modules/basculeMobile/bascule-mobile.module';

// app legacy remove if not reused after migration
import { SharedModule } from '@shared/shared.module';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

// common-components
import { GlobalErrorHandler,KvCommonComponentsModule } from '@kv-common-components/kv-common-components';
import { KxServicesModule } from '@kv-common-components/kx-services';
import { UserIdleModule } from 'angular-user-idle';
import { PasswordLoggedOutResetModule } from '@modules/password-logged-out-reset/password-logged-out-reset.module';

@NgModule({
    declarations: [AppComponent],
    imports: [
        PasswordLoggedOutResetModule,
        ActivationModule,
        BasculeMobileModule,
        ConnexionModule,
        EspaceClientModule,
        SouscriptionModule,
        BrowserModule,
        FormsModule,
        BrowserAnimationsModule,
        HttpClientModule,
        AppRoutingModule,
        SharedModule,
        LoggerModule.forRoot(environment.loggerConfig),
        KvCommonComponentsModule.forRoot({
            bundleHostUrl: environment.bundleHostUrl,
        }),
        KxServicesModule.forRoot({ apiUrl: environment.apiUrl }),
        UserIdleModule.forRoot({ idle: 0, timeout: 0, ping: 0 }),
    ],
    providers: [{ provide: ErrorHandler, useClass: GlobalErrorHandler }],
    bootstrap: [AppComponent],
})
export class AppModule {}
